import { Button, Modal } from "react-bootstrap";

interface IProps {
    show: boolean;
    bloodDrawDate: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const BloodDrawDateConfirmModal = (props: IProps) => {
    return (
        <Modal backdrop="static" show={props.show} onHide={props.onCancel}>
            <Modal.Header>
                <Modal.Title>Confirm Blood Draw Date</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>Please confirm that the selected blood draw date is correct.</p>
                <p>
                    <strong>Selected Blood Draw Date: {props.bloodDrawDate}</strong>
                </p>
                <p>
                    Once confirmed, both the Donor and Recipient Centers will be notified of the new
                    blood draw date via email.
                </p>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="primary" onClick={props.onConfirm}>
                    Confirm
                </Button>
                <Button bsStyle="default" onClick={props.onCancel}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BloodDrawDateConfirmModal;
